import { Expose } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class InvoiceLine extends Entity<InvoiceLine> {
    @Expose()
    description!: string
}
